import Auth_API from "./apiConfig";

export const chatApi = {
  getContacts: async (params = "") => {
    try {
      const response = await Auth_API.get(`/chats/contacts`, { params });
      return response.data; // Ensure response is returned correctly
    } catch (error) {
      console.error("Get contacts failed", error?.response?.data || error.message);
      throw error; // Ensure error is propagated
    }
  },

  getMessages: async (params) => {
    try {
      const response = await Auth_API.get(`/chats/messages`, { params });
      return response.data;
    } catch (error) {
      console.error("Get messages failed", error?.response?.data || error.message);
      throw error; 
    }
  },

  sendMessage: async (params) => {
    try {
      const response = await Auth_API.post(`/chats/messages/send`, params);
      return response.data;
    } catch (error) {
      console.error("Send message failed", error?.response?.data || error.message);
      throw error;
    }
  },


}
